export default __webpack_public_path__ + "static/media/a.40dbe836.svg";